import type { Locale } from "@/lib/i18n";
import { pl, type WClientTestimonialsCardsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wClientTestimonialsCardsTranslations: Record<Locale, WClientTestimonialsCardsTranslations> = {
  pl,
  en,
  de,
};

export type { WClientTestimonialsCardsTranslations };
